module.exports = __webpack_public_path__ + "img/1fab4.f1a6da3.svg";